import { useState } from "react";
import { Button, Input } from "@oc-labs/wt-storybook";
import ModalV2 from "../ModalV2";
import useModal from "../../hooks/useModal";

export default function ModalCreateAPIKey({ onCreate }) {
    const modal = useModal("createApiKey");
    const [name, setName] = useState("");

    const handleClose = () => {
        setName("");
        modal.close();
    };

    const handleSubmit = () => {
        if (name.trim()) {
            onCreate(name);
            handleClose();
        }
    };

    return (
        <ModalV2 name="createApiKey" title="Create API Key" className="min-w-sm">
            <div className="mt-4 space-y-4">
                <Input
                    label="Name"
                    placeholder="Enter API Key name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </div>
            <div className="mt-6 flex gap-2">
                <Button
                    type="tertiary"
                    onClick={handleClose}
                    className="w-1/2"
                >
                    Cancel
                </Button>
                <Button
                    type="primary"
                    onClick={handleSubmit}
                    className="w-1/2"
                >
                    Create
                </Button>
            </div>
        </ModalV2>
    );
}
